import React from "react";
import Sidebar from './layout/Sidebar';
import Header from './layout/Header';
import {
    Breadcrumb,
} from 'react-bootstrap';

const Layout = ({ children, title }) => {

    return (
        <>
            <div>
                <Header title={title}/>
                <Sidebar />
                <div className='mb-3 maincontent_div'>
                <div className="mainbreadcrumb d-block d-md-none mb-3"> 
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={(e) => e.preventDefault()}>Pages</Breadcrumb.Item>
                        <Breadcrumb.Item active>{title}</Breadcrumb.Item>
                    </Breadcrumb>
                    </div>
                    {children}
                </div>
            </div>
        </>
    )
}

export default Layout;